import { Star, Heart, Sparkles, Sun, Cloud, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 px-4 overflow-hidden"
    >
      {/* Floating stickers */}
      <Star
        size={48}
        className="absolute top-28 left-[8%] text-[#FFD166] fill-[#FFD166] animate-float"
        style={{ "--rot": "-12deg" }}
      />
      <Heart
        size={36}
        className="absolute top-44 right-[10%] text-[#FF6B9E] fill-[#FF6B9E] animate-float"
        style={{ "--rot": "15deg", animationDelay: "0.6s" }}
      />
      <Cloud
        size={56}
        className="absolute top-60 left-[14%] text-[#4DB8FF] fill-[#4DB8FF] animate-float"
        style={{ "--rot": "8deg", animationDelay: "1.2s" }}
      />
      <Sparkles
        size={40}
        className="absolute bottom-32 right-[16%] text-[#38E5B6] animate-float"
        style={{ "--rot": "-6deg", animationDelay: "0.3s" }}
      />
      <Sun
        size={64}
        className="absolute -top-2 right-[40%] text-[#FF8E72] animate-spin-slow"
      />

      <div className="max-w-5xl mx-auto text-center relative">
        {/* Badge */}
        <div
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 bg-white border-2 border-gray-900 rounded-full px-5 py-2 mb-8 shadow-pop-sm animate-pop-in"
        >
          <span className="w-2.5 h-2.5 rounded-full bg-[#38E5B6] animate-pulse"></span>
          <span className="font-bold text-sm text-gray-800">
            Run by 6 awesome 10–11 year olds · based in Hornsby
          </span>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-title"
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] text-gray-900 mb-6"
        >
          The{" "}
          <span className="relative inline-block">
            <span className="relative z-10 text-[#FF6B9E]">Baby</span>
            <span className="absolute inset-x-0 bottom-1 h-4 bg-[#FFD166] -z-0 -rotate-1"></span>
          </span>
          sitting
          <br />
          <span className="inline-block -rotate-2 bg-[#4DB8FF] text-white px-6 py-2 border-4 border-gray-900 rounded-3xl shadow-pop mt-4">
            Club!
          </span>
        </h1>

        {/* Subtitle */}
        <p
          data-testid="hero-subtitle"
          className="font-body text-lg sm:text-xl md:text-2xl text-gray-700 max-w-2xl mx-auto mb-10 font-semibold"
        >
          Hi! We're <span className="text-[#FF6B9E] font-extrabold">Natania, Grace, Alena, Neytra, Sadie & Elena</span> — your friendly neighborhood babysitting crew, ready to bring the fun. 
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-2 bg-[#FF6B9E] text-white font-display text-lg sm:text-xl px-7 py-4 rounded-full border-4 border-gray-900 shadow-pop btn-pop"
          >
            Book Us Today
            <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#team"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-2 bg-white text-gray-900 font-display text-lg sm:text-xl px-7 py-4 rounded-full border-4 border-gray-900 shadow-pop-sm btn-pop"
          >
            Meet the Crew
          </a>
        </div>

        {/* Stats / fun facts strip */}
        <div className="mt-16 grid grid-cols-3 gap-3 sm:gap-6 max-w-3xl mx-auto">
          {[
            { n: "2", l: "Sitters Per Job", c: "bg-[#FF6B9E]" },
            { n: "100%", l: "Pure Fun", c: "bg-[#FFD166]" },
            { n: "Lots", l: "Of Snacks (if allowed!)", c: "bg-[#38E5B6]" },
          ].map((s, i) => (
            <div
              key={i}
              data-testid={`hero-stat-${i}`}
              className={`${s.c} border-4 border-gray-900 rounded-3xl p-4 sm:p-5 shadow-pop-sm`}
              style={{ transform: `rotate(${i === 1 ? 2 : i === 0 ? -2 : 1}deg)` }}
            >
              <div className="font-display text-2xl sm:text-4xl text-gray-900">{s.n}</div>
              <div className="font-bold text-xs sm:text-sm text-gray-900 mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
